import React from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { createLawyer, NewLawyerData } from '../../../services/lawyerService';
import formStyles from '../trainees/TraineeForm.module.css'; // إعادة استخدام نفس ملف التنسيق

const AddLawyerPage: React.FC = () => {
  const navigate = useNavigate();
  const { 
    register, 
    handleSubmit, 
    formState: { errors, isSubmitting } 
  } = useForm<NewLawyerData>();

  const onSubmit: SubmitHandler<NewLawyerData> = (data) => {
    const submissionData = {
      ...data,
      user_id: Number(data.user_id), // التأكد من أن user_id رقم
    };

    const promise = createLawyer(submissionData);

    toast.promise(promise, {
      loading: 'جاري حفظ المحامي...',
      success: () => {
        navigate('/admin/lawyers/list');
        return 'تمت إضافة المحامي بنجاح!';
      },
      error: (err) => err.response?.data?.message || 'فشل في إنشاء المحامي.',
    });
  };

  return (
    <div className={formStyles.pageContainer}>
      <div className={formStyles.formContainer}>
        <h2 className={formStyles.title}>إضافة محامٍ جديد</h2>
        <form onSubmit={handleSubmit(onSubmit)} className={formStyles.form}>
          
          <div className={formStyles.formField}>
            <label htmlFor="name" className={formStyles.label}>اسم المحامي</label>
            <input id="name" {...register('name', { required: 'الاسم مطلوب' })} className={formStyles.input} />
            {errors.name && <p className={formStyles.error}>{errors.name.message}</p>}
          </div>

          <div className={formStyles.formField}>
            <label htmlFor="bar_number" className={formStyles.label}>رقم القيد بالنقابة</label>
            <input id="bar_number" {...register('bar_number', { required: 'رقم القيد مطلوب' })} className={formStyles.input} />
            {errors.bar_number && <p className={formStyles.error}>{errors.bar_number.message}</p>}
          </div>

          <div className={formStyles.formField}>
            <label htmlFor="specialization" className={formStyles.label}>التخصص</label>
            <input id="specialization" {...register('specialization', { required: 'التخصص مطلوب' })} className={formStyles.input} />
            {errors.specialization && <p className={formStyles.error}>{errors.specialization.message}</p>}
          </div>

          <div className={formStyles.formField}>
            <label htmlFor="city" className={formStyles.label}>المدينة</label>
            <input id="city" {...register('city', { required: 'المدينة مطلوبة' })} className={formStyles.input} />
            {errors.city && <p className={formStyles.error}>{errors.city.message}</p>}
          </div>

          <div className={formStyles.formField}>
            <label htmlFor="email" className={formStyles.label}>البريد الإلكتروني</label>
            <input id="email" type="email" {...register('email', { required: 'البريد الإلكتروني مطلوب' })} className={formStyles.input} />
            {errors.email && <p className={formStyles.error}>{errors.email.message}</p>}
          </div>

          <div className={formStyles.formField}>
            <label htmlFor="phone" className={formStyles.label}>رقم الهاتف</label>
            <input id="phone" type="tel" {...register('phone', { required: 'رقم الهاتف مطلوب' })} className={formStyles.input} />
            {errors.phone && <p className={formStyles.error}>{errors.phone.message}</p>}
          </div>

          <div className={formStyles.formField}>
            <label htmlFor="user_id" className={formStyles.label}>معرف المستخدم (User ID)</label>
            <input id="user_id" type="number" {...register('user_id', { required: 'معرف المستخدم مطلوب', valueAsNumber: true })} className={formStyles.input} />
            {errors.user_id && <p className={formStyles.error}>{errors.user_id.message}</p>}
          </div>

          <div className={formStyles.formField}>
            <label htmlFor="join_date" className={formStyles.label}>تاريخ الانضمام</label>
            <input id="join_date" type="date" {...register('join_date', { required: 'تاريخ الانضمام مطلوب' })} className={formStyles.input} />
            {errors.join_date && <p className={formStyles.error}>{errors.join_date.message}</p>}
          </div>

          <div className={`${formStyles.formField} ${formStyles.fullWidth}`}>
            <label htmlFor="expiry_date" className={formStyles.label}>تاريخ انتهاء الاشتراك</label>
            <input id="expiry_date" type="date" {...register('expiry_date', { required: 'تاريخ الانتهاء مطلوب' })} className={formStyles.input} />
            {errors.expiry_date && <p className={formStyles.error}>{errors.expiry_date.message}</p>}
          </div>
          
          <div className={formStyles.buttonContainer}>
            <Link to="/admin/lawyers/list" className={formStyles.cancelButton}>إلغاء</Link>
            <button type="submit" disabled={isSubmitting} className={formStyles.submitButton}>
              {isSubmitting ? 'جاري الحفظ...' : 'حفظ المحامي'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddLawyerPage;
